// *******************************************************************************************************************************
// * appad from appbase
// *******************************************************************************************************************************

import React from "react";
import Icon from '../../components/bases/icone/icon.js';

import AppBase from '../appBase.js';
import AppSettings from './appcomponents/appsettings/appsettings.js';
import AppHeader from './appcomponents/appheader/appheader.js';

import { GlobalProvider } from "../../utils/globalprovider.js";

import { AppResizeHandle } from "../../utils/apputils.js";
import { appAsset_getAssetById,appAsset_getFirstAssetByType } from "../../utils/apputils.js";
import { appAsset_generateUUID, appAsset_getCurrentDate } from "../../utils/apputils.js";

import { apiReadOneVideo } from "../../utils/apis.js";
import { getVideoPath, getCpPaths, getAudioPath } from "../../utils/apis.js";
import { configurations_getDefaultParams } from "../../utils/configurations.js";

import VideoPlayerST from '../../components/bases/videoplayer/videoplayerst.js';
import AssetsManager from './appcomponents/assetsmanager/assetsmanager.js';
import TimeLine from './appcomponents/timeline/timeline.js';
import ToolsBar from '../../components/bases/toolsbar/toolsbar.js';
import User from "./appcomponents/user/user.js"

import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import styles from "../appstyles/styles.module.css" 
import EnTravaux from '../../components/bases/entravaux/entravaux.js';
import { apiCreateFromAsset,apiReadOneAsset, apiSearchAssetsFromProject } from '../../utils/apis.js';

import { directDownloadTxt,directDownloadJson } from '../../utils/download.js';

import {getStickyWordsList} from '../../utils/download.js';

import { checkSubtitle } from '../../utils/checksubtitles.js';

import { keyboard_special_down, keyboard_special_up} from "../../utils/keyboard.js";
import { keyboard_multi_getShorCutList_by_apps_and_keyboard } from "../../utils/keyboard_multi.js";
import { keyboard_multi_getKey } from "../../utils/keyboard_multi.js";

import {getCurrentProjectDatas, getMaxUndo} from "../../utils/software.js"
import { getlocalhostDatas } from '../../utils/apis.js';

import { GlobalContext, UploadComponentRef } from '../../utils/globalprovider.js';
import imgblue from "./assets/toolsbar/blue.png"
import imggreen from "./assets/toolsbar/green.png"
import imgcyan from "./assets/toolsbar/cyan.png"
import imgred from "./assets/toolsbar/red.png"
import imgmagenta from "./assets/toolsbar/magenta.png"
import imgyellow from "./assets/toolsbar/yellow.png"
import imgwhite from "./assets/toolsbar/white.png"

import imgcreatefromsubtitles from "./assets/toolsbar/createfromsubtitles.png"
import imgcreatefromvoice from "./assets/toolsbar/createfromvoice.png"
import imgcadenas from "./assets/toolsbar/cadenas.png"
import imgsimul from "./assets/toolsbar/simul.png"


import ftva from "../../assets/ftva.png"
import easytt from "../../assets/logoEasyTTSmall.png"

// Emmanuelle
import { cloneDeep, first, flatMapDeep, last } from 'lodash';

import EditListSt from "./appcomponents/subtitles/list-st/edit-list-st.js";
import { V2_ConvertSecondToTimeCodeStringFromAsset, V2_ConvertTimeCodeStringToSecondFromAsset, V2_getIntervalStringFromAsset } from "../../utils/timecodev2.js";




class AppAd extends AppBase
{
    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);
        // *********************************************************************************************************************
        // app
        // *********************************************************************************************************************
        this.onCancelKeyboardEvent = this.onCancelKeyboardEvent.bind(this);
        this.cancelKeyboardEvent=false;
        this.appHeaderRef = React.createRef();
        this.bodyDivRef = React.createRef();
        this.divEditSTRef = React.createRef();
        this.transcriptRef = React.createRef();
        this.state.pjid = getCurrentProjectDatas().pjid;
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.autoSave = this.autoSave.bind(this);
        this.saveSubtitles = this.saveSubtitles.bind(this);
        this.OtherFilesdownloadDone = this.OtherFilesdownloadDone.bind(this);
        this.shortcuts_list = [];
        

        this.SubtitlesisModified = false; 
        this.initialised = false;
        // *********************************************************************************************************************
        // app subtitles specifics functions
        // *********************************************************************************************************************
        this.app_FirstassetsDownloaded = false;
        this.appSubtitles_SearchFirstCurrentAssets = this.appSubtitles_SearchFirstCurrentAssets.bind(this);
        this.appSubtitles_SetCurrentToAssetsManager = this.appSubtitles_SetCurrentToAssetsManager.bind(this);
        this.appSubtitles_startWithOneVideoCallback = this.appSubtitles_startWithOneVideoCallback.bind(this);
        this.appSubtitles_apiCallBackReadOneAsset = this.appSubtitles_apiCallBackReadOneAsset.bind(this);
        this.appSubtitles_apiCallBackReadOneAssetOriginal = this.appSubtitles_apiCallBackReadOneAssetOriginal.bind(this);
        this.appSubtitles_apiCallBackReadOneAssetCorrected = this.appSubtitles_apiCallBackReadOneAssetCorrected.bind(this)
        this.appSubtitles_apiCallBackCreateOneAssetFromOriginal = this.appSubtitles_apiCallBackCreateOneAssetFromOriginal.bind(this)
        this.app_subtitles_checkSubtitle = this.app_subtitles_checkSubtitle.bind(this);
        this.assetsList = [];
        this.currentVideoId = -1;
        this.currentOriginalSubtitle = -1;
        this.currentCorrectedSubtitle = -1;
        this.currentOriginalTranscription = -1;
        this.currentCorrectedTranscription = -1;
  
        this.getTimeCodeString = this.getTimeCodeString.bind(this)
        this.getIntervalString = this.getIntervalString.bind(this)

        this.startWithSubtitle = this.startWithSubtitle.bind(this)


        // *********************************************************************************************************************
        // Assets Manager
        // *********************************************************************************************************************

        this.onClickOnAsset = this.onClickOnAsset.bind(this)
        this.onAssetsManagerChange = this.onAssetsManagerChange.bind(this)
        this.assetsManagerRef = React.createRef();

        // *********************************************************************************************************************
        // Params
        // *********************************************************************************************************************
        this.onchangeparams = this.onchangeparams.bind(this)

        this.subtitleParameters = configurations_getDefaultParams();
        // *********************************************************************************************************************
        // Tool Bar
        // *********************************************************************************************************************

        this.state.toolsbar =
        { 
            height: 18,


            families:[
              {
                    fr: "couleurs",
                    en: "colors",

                items: [
                  {img: imgblue ,type:"button", disable:false,fr:"Bleu",en:"Blue", nochangecolor:true, key:{key:"BLUE", cat:"transcriptshortcut"}},
                  {img: imggreen ,type:"button", disable:false,fr:"Vert",en:"Green", nochangecolor:true, key:{key:"GREEN", cat:"transcriptshortcut"}},
                  {img: imgcyan ,type:"button", disable:false,fr:"Cyan",en:"Cyan", nochangecolor:true, key:{key:"CYAN", cat:"transcriptshortcut"}},
                  {img: imgred ,type:"button", disable:false,fr:"Rouge",en:"Red", nochangecolor:true, key:{key:"RED", cat:"transcriptshortcut"}},
                  {img: imgmagenta ,type:"button", disable:false,fr:"Magenta",en:"Magenta", nochangecolor:true, key:{key:"MAGENTA", cat:"transcriptshortcut"}},
                  {img: imgyellow ,type:"button", disable:false,fr:"Jaune",en:"Yellow", nochangecolor:true, key:{key:"YELLOW", cat:"transcriptshortcut"}},
                  {img: imgwhite ,type:"button", disable:false,fr:"Blanc",en:"White", nochangecolor:true, key:{key:"WHITE", cat:"transcriptshortcut"}},

                ],
              },
              {
                    fr: "mode",
                    en: "mode",

                items: [
                  {toogle: true, value:false, img: imgcadenas ,type:"button", disable:false,fr:"Faire suivre la vidéo",en:"Lock video", nochangecolor:false, key:{key:"LOCKVIDEO", cat:"transcriptshortcut"}},
                  {toogle: true, value:false, img: imgsimul ,type:"button", disable:false,fr:"Simulation en play",en:"Simulation when play", nochangecolor:false, key:{key:"SIMUL", cat:"transcriptshortcut"}},

                ],
              },
              {
                    fr: "Divers",
                    en: "Miscellianous",

                items: [
                  {toogle: true, value:false, img: imgcreatefromsubtitles ,type:"button", disable:false,fr:"Création automatique à partir des sous-titres",en:"Automatic creation from subtitles", nochangecolor:false, key:{key:"LOCKVIDEO", cat:"transcriptshortcut"}},
                  {toogle: true, value:false, img: imgcreatefromvoice ,type:"button", disable:false,fr:"Création automatique à partir de la transcription",en:"automatic creation from transcriptions", nochangecolor:false, key:{key:"SIMUL", cat:"transcriptshortcut"}},

                ],
              },


            ],
          }        
        
        
        this.onClickToolsBar = this.onClickToolsBar.bind(this)
     
        // *********************************************************************************************************************
        // Player
        // *********************************************************************************************************************
        this.playerparams = 
        {
            background: false,
            displaytc: true,
            displaytcms: true,
            dontscale: true,
        }

        this.state.videopath =  ""; 
        this.state.videoready = false;
        this.state.videoforplayer =  null;

        this.state.framerate= 25.0;
        this.state.num = 25;
        this.state.den =  1;

      this.state.timecodeAsset =
      {
        asid: 0,
        asframerate: 25,
        asnum: 25,
        asden: 1,
        asdropframe: 0,
        astimecode: "00:00:00:00",
      };


        this.videoPlayerRef = React.createRef();
        this.onNewTime = this.onNewTime.bind(this)
        this.videoReady = this.videoReady.bind(this)


        // *********************************************************************************************************************
        // Time Line
        // *********************************************************************************************************************

        this.timelinePanelRef = React.createRef();
        this.timelineRef = React.createRef();
        

        
        this.state.timelineHeight = 30;
        this.state.timelineHeightInPixel = 10;
        
        this.handleTimeLineWheel = this.handleTimeLineWheel.bind(this)
        this.handleGotoTime = this.handleGotoTime.bind(this)
        this.forceResizeTimeLine = this.forceResizeTimeLine.bind(this);
        

          this.appSubtitles_onReadVideoForCP = this.appSubtitles_onReadVideoForCP.bind(this)
          this.appSubtitles_onReadVideoForAudio1 = this.appSubtitles_onReadVideoForAudio1.bind(this)
          this.appSubtitles_onReadVideoForAudio2 = this.appSubtitles_onReadVideoForAudio2.bind(this)
          this.setSubtitlesChange = this.setSubtitlesChange.bind(this)
          this.handleCpListLoaded = this.handleCpListLoaded.bind(this)

        // *********************************************************************************************************************
        // subtitle list
        // *********************************************************************************************************************

        this.editListeStRef = React.createRef();
        this.subtitleParameters = configurations_getDefaultParams();
    
        this.displayParameters = {
          fontName: 'Arial', // « nom de la police à utiliser »
          borderWidth: '5px', // épaisseur de la bordure autour du caractère
          borderColor: 'black', // « black »
          marginLeft: '5%',
          marginRight: '5%',
          marginTop: '5%',
          marginBottom: '5%',
        };
  
        this.subtitlelist_move = this.subtitlelist_move.bind(this);
        this.subtitlelist_change = this.subtitlelist_change.bind(this);
        this.subtitlelist_applyFilter =this.subtitlelist_applyFilter.bind(this);
        this.subtitlelist_addNewActionForUndo = this.subtitlelist_addNewActionForUndo.bind(this);
        this.subtitlelist_onUndoOrRedo = this.subtitlelist_onUndoOrRedo.bind(this);
        this.subtitlelist_setNewCorrectedSubtitles = this.subtitlelist_setNewCorrectedSubtitles.bind(this);


        this.subtitlelist_nextSubtitle = this.subtitlelist_nextSubtitle.bind(this)
        this.subtitlelist_prevSubtitle = this.subtitlelist_prevSubtitle.bind(this)
      
        this.subtitle_onChangeSubtitle = this.subtitle_onChangeSubtitle.bind(this);

        this.state.undo = []
        this.state.redo = [];

        this.state.subtitles=  []; // Liste des sous-titres
        this.state.currentSubtitleIndex =  0; // Index du sous-titre actif

        this.subtitlesChanged = false;
        this.subtitlesToSave = null;
  
    }




    // *********************************************************************************************************************
    // formatage time code
    // *********************************************************************************************************************
  getTimeCodeString(time) {
    return V2_ConvertSecondToTimeCodeStringFromAsset(time, this.state.timecodeAsset);
  }
      
  getIntervalString(timebefore, time) {
    return V2_getIntervalStringFromAsset(timebefore, time, this.state.timecodeAsset, this.playerparams.displaytcms);
  }


    startWithSubtitle(subtitle)
    {
      // a faire on a changer de sous titre
    }

    appSubtitles_computeAllSubtitles()
    {
      // to do
    }

    // *********************************************************************************************************************
    // keyboard Events
    // *********************************************************************************************************************
    onCancelKeyboardEvent(value)
    {
      this.cancelKeyboardEvent =  value;
    }

    handleKeyUp = (event) =>
        {
          
          if (this.cancelKeyboardEvent) return;
          
          const ret  = keyboard_special_up( event.code, event.key, event.shift, event.ctrl, event.alt);
    
          if (ret !=="" )
          {
            var char = event.key;
            var code = char.codePointAt(0);
            
            if (code >= 32) 
            {
              if (this.subtitle_GetEditSubtitleRef())
                this.subtitle_GetEditSubtitleRef().addChar(char);
              if (this.editListeStRef && this.editListeStRef.current)
                this.editListeStRef.current.addChar(char);
            }              
              
             
          }
    
        }



    handleKeyDown = (event) =>
    {
      
      if (this.cancelKeyboardEvent) return;
       if (keyboard_special_down(event.code, event.key, event.shiftKey, event.ctrlKey, event.altKey)) return;
      
    
    }
    // *********************************************************************************************************************
    // timeline Events
    // *********************************************************************************************************************

    handleGotoTime(value)
    {
      if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
        this.videoPlayerRef.current.goto(value);
    }
  
    handleTimeLineWheel(value)
    {
      
      if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
        this.videoPlayerRef.current.addtime(value);
    }

    forceResizeTimeLine (newHeight)
    {

        if ((this.bodyDivRef) && (this.bodyDivRef.current))
        {
          const containerHeight = this.bodyDivRef.current.clientHeight;
          const percentage = (newHeight / containerHeight) * 100;


          this.setState({
              timelineHeight: percentage,
              timelineHeightInPixel: newHeight,
          })

          
          this.timeout = setTimeout(() => {

            if ((this.timelinePanelRef) && (this.timelinePanelRef.current))
              this.timelinePanelRef.current.resize(percentage);
          }, 50);          
        }
    }
    // *********************************************************************************************************************
    // app subtitles specifics functions
    // *********************************************************************************************************************

    app_subtitles_checkSubtitle(previous, st, next)
    {
      return checkSubtitle(previous, st, next, this.subtitleParameters);
    }



    appSubtitles_SetCurrentToAssetsManager()
    {
      if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
        {
          this.assetsManagerRef.current.setNewCurrent(
          {
            video: this.currentVideoId,
            originaltr: this.currentOriginalTranscription,
            correctedtr: this.currentCorrectedTranscription,
            calculatedsubtitles: this.currentOriginalSubtitle,
            correctedsubtitle: this.currentCorrectedSubtitle,
            finaltr: 0,                    
        })
        }

    }    
    appSubtitles_FirstDownloadProjectAssets()
    {
      // Premier lancement de l'app, on charge la liste des assets pour determiner les assets de départ
      if (this.app_FirstassetsDownloaded) return;
      if (this.state.pjid !== 0)
        apiSearchAssetsFromProject({pjid: this.state.pjid}, this.appSubtitles_SearchFirstCurrentAssets); // C'est le grand départ
      this.app_FirstassetsDownloaded = true;
    }

    appSubtitles_SearchFirstCurrentAssets(datas)
    {
      this.assetsList = datas;

      this.currentVideoId = -1;
      this.currentOriginalSubtitle = -1;
      this.currentCorrectedSubtitle = -1;
      this.currentOriginalTranscription = -1;
      this.currentCorrectedTranscription = -1;



      // Stade 1 , on regarde si on a une vidéo
      this.appSubtitles_checkOpenFirstVideo();

      // Stade 2, on regarde si on a un fichier de subtitles corrigés
      var asset = appAsset_getFirstAssetByType(this.assetsList, 5);
      if (asset !== null)
      {
          this.currentCorrectedSubtitle = asset.asid;
          apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetCorrected);
          // on regarde si on a des sous-titres calculés par rapport à ces sous-titres
          asset = appAsset_getAssetById(this.assetsList, asset.asoriid);
          if (asset !== null)
          {
            apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetOriginal);
          }
      

      } 
      else
      {
          asset = appAsset_getFirstAssetByType(this.assetsList, 4);
          if (asset !== null)
          {
              
              apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetOriginal);
              // il faut créer maintenant des sous-titres à partir de ça
              // on peut en créer une à partir de l'original

              const pjid = getCurrentProjectDatas().pjid;
              var datas  = 
              {
                asid: 0,
                aspjid: pjid,
                astype: 5, // sous titres  corrigés
                asviid: 0,
                asoriid: asset.asid, // transcription originale
                astitle: asset.astitle,
                asfile: appAsset_generateUUID(),
                originalfile: asset.asfile,
                aslang: asset.aslang,
                asext: asset.asext,
                assubtype: asset.assubtype,
                ascreatedate: appAsset_getCurrentDate(),
                asupdatedate: appAsset_getCurrentDate(),
              }
              
              apiCreateFromAsset(datas, this.appSubtitles_apiCallBackCreateOneAssetFromOriginal)





          }
          else
          {
            // aucun fichier de sous-titres
          }
      }

    }

    // ******************************************************
    //  call back lecture/ creation assets original/ corrigé
    // ******************************************************
    appSubtitles_apiCallBackCreateOneAssetFromOriginal(datas)
    {
        if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
        {
            if (datas.ret)
            {
              this.assetsManagerRef.current.reloadAllAssets();
              apiReadOneAsset ({asid: datas.id}, this.appSubtitles_apiCallBackReadOneAssetCorrected);
            };
          }
    }

    appSubtitles_apiCallBackReadOneAssetOriginal(datas)    
    {
      this.appSubtitles_apiCallBackReadOneAsset(datas,true)  
    }
    appSubtitles_apiCallBackReadOneAssetCorrected(datas)    
    {
      this.appSubtitles_apiCallBackReadOneAsset(datas,false)  
    }


    appSubtitles_readCorrectedTranscription(asoriid)
    {
      
      var asset = appAsset_getAssetById(this.assetsList, asoriid);
      if (asset)
      {
        if (asset.astype === 2) // corrected transcription
        {
          
          apiReadOneAsset ({asid: asoriid}, this.appSubtitles_apiCallBackReadOneAsset);
          if (asset.asoriid > 0)
            apiReadOneAsset ({asid: asset.asoriid}, this.appSubtitles_apiCallBackReadOneAsset);
        }
      }
    }


    appSubtitles_apiCallBackReadOneAsset(datas,original=true)
    {
        if (datas.ret)
        {
            switch (datas.astype)
            {
              case 1:     // original transcription
                console.log("case 1 ", datas)
                this.currentOriginalTranscription = datas.asid;
                this.appSubtitles_SetCurrentToAssetsManager();
                var indextr = this.timelineRef.current.getIndexByType("trjson");
                if (indextr == -1)
                  this.timelineRef.current.addTrack ("trjson",JSON.parse(datas.asdatas), datas.astitle,"",0,this.currentOriginalTranscription);
                else
                  this.timelineRef.current.setNewDatas (indextr, JSON.parse(datas.asdatas), this.currentOriginalTranscription);
                  this.timelineRef.current.forceRecreate();

                  if ((this.transcriptRef) && (this.transcriptRef.current))
                    this.transcriptRef.current.setOriginalTranscription(JSON.parse(datas.asdatas),datas.asid,-1,datas.astitle,datas.asfile);

                break;
              case 2:     // corrected transcription
                this.currentCorrectedTranscription = datas.asid;
                this.appSubtitles_SetCurrentToAssetsManager();
                var indextr = this.timelineRef.current.getIndexByType("newtrjson");
                // on ajoute la piste de transcription si elle n'existe pas
                if (indextr == -1)
                  this.timelineRef.current.addTrack ("newtrjson",JSON.parse(datas.asdatas), datas.astitle,"",0,this.currentCorrectedTranscription);
                else
                  this.timelineRef.current.setNewDatas (indextr, JSON.parse(datas.asdatas), this.currentCorrectedTranscription);
                console.log(datas.asdatas)
                  this.timelineRef.current.forceRecreate();
                  if ((this.transcriptRef) && (this.transcriptRef.current))
                    this.transcriptRef.current.setTranscription(JSON.parse(datas.asdatas),datas.asid,-1,datas.astitle,datas.asfile);

                break;
              case 4:     // computed subtitles
                // c'est toujours des originaux
                
                this.currentOriginalSubtitle = datas.asid;
                this.appSubtitles_SetCurrentToAssetsManager();
                var subtitles   = JSON.parse(datas.asdatas);
                const indexst = this.timelineRef.current.getIndexByType("oldst");
                // on ajoute la piste de sous-titre si elle n'existe pas
                if (indexst === -1)
                  this.timelineRef.current.addTrack ("oldst",[], "subtitles", "",0,this.currentOriginalSubtitle);
        
                this.timelineRef.current.setNewSubtitlesByType(subtitles.subtitles, this.currentOriginalSubtitle,"oldst");
                this.timelineRef.current.forceRecreate();
                this.appSubtitles_readCorrectedTranscription(datas.asoriid);

                break;
              case 5:     // corrected subtitles
                  if (original)
                  {
                    
                    this.currentOriginalSubtitle = datas.asid;
                    this.appSubtitles_SetCurrentToAssetsManager();
                    var subtitles   = JSON.parse(datas.asdatas);

                    const indexst = this.timelineRef.current.getIndexByType("oldst");
                    // on ajoute la piste de sous-titre si elle n'existe pas
                    if (indexst === -1)
                      this.timelineRef.current.addTrack ("oldst",[], "subtitles", "",0,this.currentOriginalSubtitle);
            
                    this.timelineRef.current.setNewSubtitlesByType(subtitles.subtitles, this.currentOriginalSubtitle,"oldst");
                    this.timelineRef.current.forceRecreate();


                    // on regarde si on a une transcription à partir de ces souis-titres calculés
                    this.appSubtitles_readCorrectedTranscription(datas.asoriid);

                    


                  }
                  else
                  {
                    
                    this.currentCorrectedSubtitle = datas.asid;
                    this.appSubtitles_SetCurrentToAssetsManager();
                    var subtitles = JSON.parse(datas.asdatas);

                    const indexst = this.timelineRef.current.getIndexByType("st");
                    // on ajoute la piste de sous-titre si elle n'existe pas
                    if (indexst === -1)
                       this.timelineRef.current.addTrack ("st",[], "subtitles", "",0,this.currentCorrectedSubtitle);
                    
                    this.timelineRef.current.setNewSubtitlesByType(subtitles.subtitles, this.currentCorrectedSubtitle,"st");
                    this.timelineRef.current.forceRecreate();
                    
                    this.subtitlelist_setNewCorrectedSubtitles(this.currentCorrectedSubtitle, JSON.parse(datas.asdatas));

                    
                  }
              break;

            }
        }
    }

    // *****************************
    //  lecture video
    // *****************************
    

    appSubtitles_checkOpenFirstVideo()
    { // recherche de la peemière vidéo utilisable
      if (this.currentVideoId>=0) return; // déja chargée 
      var asset = appAsset_getFirstAssetByType (this.assetsList, 3);
      this.appSubtitles_StartNewVideo(asset)
      
    }

    appSubtitles_StartNewVideo(asset)
    {
        this.currentVideoId = -1;
        this.appSubtitles_SetCurrentToAssetsManager();
        if (asset)
        {

            this.currentVideoId = asset.asviid;
            console.log("first video asset ", asset)
            this.appSubtitles_SetCurrentToAssetsManager();
            apiReadOneVideo({viid: asset.asviid},this.appSubtitles_startWithOneVideoCallback);
        }
    }

    appSubtitles_startWithOneVideoCallback(datas)
    {
        if ("ret" in datas) return; // forcement en erreur

        

        if (datas.length !==0)
        {
          console.log("start one ", datas)
          const videofile = getVideoPath(datas[0]);

          const framerate = datas[0].viframerate.toFixed(2).replace('.', ','); // "1234,56"
          const num = datas[0].vinum;
          const den = datas[0].viden;

          
          this.currentVideoId = datas[0].viid;
          this.appSubtitles_SetCurrentToAssetsManager();
          this.setState(
            {
              framerate: framerate,
              den: den,
              num: num,

              videopath: videofile, 
              videoready: true, 
              videoforplayer: datas[0]}
          );
          if ((this.timelineRef) && (this.timelineRef.current))
          {
            this.appSubtitles_onReadVideoForCP(datas);
            this.appSubtitles_onReadVideoForAudio1(datas);
            this.appSubtitles_onReadVideoForAudio2(datas);
          }
          
          
          //this.assetsManagerRef.current.reloadAllAssets();
        }


    }      

    handleCpListLoaded(cplist)
    {
      
      this.subtitleParameters.cplist = cplist;
      this.appSubtitles_computeAllSubtitles();
      
    }

    appSubtitles_onReadVideoForCP(datas)
    {
      const cpfiles = getCpPaths(datas[0]);

      //this.timelineRef.current.addTrack ("mp4zcp",null, cpfiles.json,cpfiles.jpegs,0, this.currentVideoId);
      if ("json" in cpfiles)
      {
          
          const indextr = this.timelineRef.current.getIndexByType("mp4zcp");
          // on ajoute la piste de cp si elle n'existe pas
          if (indextr == -1)
            this.timelineRef.current.addTrack ("mp4zcp",null, cpfiles.json,cpfiles.jpegs,0, datas[0].viid);
          else
            this.timelineRef.current.setNewDatas (indextr, cpfiles.json, datas[0].viid, cpfiles.jpegs);
          this.timelineRef.current.forceRecreate();
      }

    }
    appSubtitles_onReadVideoForAudio1(datas)
    {
      const audiofile1 = getAudioPath(1, datas[0]);
      if (audiofile1 ==="") return;

      const indextr = this.timelineRef.current.getIndexByTypeAndChannel("mp4zaudio", 1);
      // on ajoute la piste de cp si elle n'existe pas
      if (indextr == -1)
        this.timelineRef.current.addTrack ("mp4zaudio",null, audiofile1,"",1, datas[0].viid);
      else
        this.timelineRef.current.setNewDatas (indextr, audiofile1, datas[0].viid);

      this.timelineRef.current.forceRecreate();

        
    }
    appSubtitles_onReadVideoForAudio2(datas)
    {
      const audiofile2 = getAudioPath(2, datas[0]);
      if (audiofile2 ==="") return;

      const indextr = this.timelineRef.current.getIndexByTypeAndChannel("mp4zaudio", 2);
      // on ajoute la piste de cp si elle n'existe pas
      if (indextr == -1)
        this.timelineRef.current.addTrack ("mp4zaudio",null, audiofile2,"",2, datas[0].viid);
      else
        this.timelineRef.current.setNewDatas (indextr, audiofile2, datas[0].viid);

      this.timelineRef.current.forceRecreate();
      
    }

    
    // *********************************************************************************************************************
    // pure app functions
    // *********************************************************************************************************************
    canClose()
    {
      return !this.SubtitlesisModified;
    }

    componentDidMount() 
    {

      this.shortcuts_list =keyboard_multi_getShorCutList_by_apps_and_keyboard(["player","voiceover"]);

      window.addEventListener('keydown', this.handleKeyDown);
      window.addEventListener('keyup', this.handleKeyUp);
      this.startIntervalAutoSave();
      if (this.initialised) return;
      this.initialised = true;
        

      if ((this.timelineRef) && (this.timelineRef.current))
      {
          var h = this.timelineRef.current.createDefaultTimeLine();
  
          const containerHeight = this.bodyDivRef.current.clientHeight;
          const percentage = (h / containerHeight) * 100;
          this.setState({
              timelineHeight: percentage,
              timelineHeightInPixel: h,
          })

          
          this.timeout = setTimeout(() => {

            this.timelinePanelRef.current.resize(percentage);
          }, 50);          
          this.timelineRef.current.setNewTimeLineSize(h);

      }
      this.downloadDefaultFiles();

      if ((this.timelineRef) && (this.timelineRef.current))
          this.timelineRef.current.setParamsST(this.subtitleParameters);


      this.appSubtitles_FirstDownloadProjectAssets(); // C'est parti
      if ((this.divEditSTRef) && (this.divEditSTRef.current))
        this.divEditSTRef.current.focus();
    }
    // Suppression de l'écouteur lorsque le composant est démonté
    componentWillUnmount() 
    {
      this.stopIntervalAutoSave();
      window.removeEventListener('keydown', this.handleKeyDown);
      window.removeEventListener('keyup',this.handleKeyUp);
    }  

    // *********************************************************************************************************************
    // autosave functions
    // *********************************************************************************************************************
    startIntervalAutoSave() 
    {
      this.intervalIdAutoSave = setInterval(() => {
        this.autoSave();
      }, 60000); 
    }
    
    stopIntervalAutoSave()
    {
      clearInterval(this.intervalIdAutoSave);
    }

    setSubtitlesChange(subtitles)
    {
      
      
      this.subtitlesChanged = true;
      this.subtitlesToSave = {
          subtitles: subtitles,
          framerate: this.state.framerate,
          den: this.state.den,
          num: this.state.num,
          pjid: this.state.pjid,
          params: this.subtitleParameters,
          display: this.displayParameters,
      }


      
          
      if ((this.timelineRef) && (this.timelineRef.current))
    {
          const indexst = this.timelineRef.current.getIndexByType("st");
          // on ajoute la piste de sous-titre si elle n'existe pas
          if (indexst === -1)
          {
              this.timelineRef.current.addTrack ("st",[], "subtitles", "",0,this.currentCorrectedSubtitle);


              this.timelineRef.current.setNewST(subtitles);
              console.log("subtitles reaffichier", subtitles)
              this.timelineRef.current.setNewSubtitlesByType(subtitles, this.currentCorrectedSubtitle,"st");
              this.timelineRef.current.forceRecreate();
              this.timelineRef.current.setNewST(subtitles);   
          }
            else
            {
              this.timelineRef.current.setNewSubtitlesByType(subtitles, this.currentCorrectedSubtitle,"st");  
            }    
          //  this.timelineRef.current.setNewSubtitlesByType(subtitles, this.currentCorrectedSubtitle,"st");


      }
    }

    canClose()
    {
      
        return !this.subtitlesChanged;

    }


    saveSubtitles()
    {
        if ((!this.subtitlesChanged) && (this.subtitleToSave)) return;
        this.subtitlesChanged = false;
        if (this.currentCorrectedSubtitle > 0)
        {
          const asset = appAsset_getAssetById(this.assetsList, this.currentCorrectedSubtitle);
          if (asset != null)
          {
            const datas = JSON.stringify(this.subtitlesToSave)

            const memoryFile = new File([datas], asset.asfile + "." +asset. asext, 
                  {
                  type: "application/json", // MIME type for JSON
                  lastModified: new Date().getTime() // Timestamp for the file
                  });            

            if ((UploadComponentRef) && (UploadComponentRef.current))
            {
              const formulaire = {
                asid: this.currentCorrectedSubtitle,
                aspjid: this.state.pjid,
                astype: asset.astype,
                uploadfile: memoryFile,
                filenamedest: asset.asfile + "." +asset. asext,
                filenamesource: asset.asfile,
                asupdatedate: appAsset_getCurrentDate(),
              }
             UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 2 ,this.onSaveDone);

          }
        }
      }


    }

    autoSave()
    {
        // to do autosave for subtitles file
        // ne pas appeler directement
        if (this.subtitlesChanged) this.saveSubtitles();


    }
        
    // ********************************************************************************************************************
    // * chargements des fichiers par default
    // *********************************************************************************************************************
    downloadDefaultFiles()
    {
        directDownloadTxt (getlocalhostDatas() + "fr/motscollants.txt",this.OtherFilesdownloadDone,"motsc") 
        directDownloadJson (getlocalhostDatas() + 'fr/common_errors_fra.json',this.OtherFilesdownloadDone,"commonerrors");
    }

    OtherFilesdownloadDone(blob, infos, file)
    {
      switch (infos)
      {
        case "motsc": // liste des mots collants
            this.motsc = getStickyWordsList(blob);
            break;

        case "commonerrors":
        {
            break;
        }
      }
    }
    


    // *********************************************************************************************************************
    // params Events
    // *********************************************************************************************************************
    onchangeparams(params)
    {
      // on a changé un paramètres dans la fenêtre de droite
      switch (params.type)
      {
        case "st":
          if ((this.timelineRef) && (this.timelineRef.current))
              this.timelineRef.current.setParamsST(this.subtitleParameters);

          break;
        case "timeline":
          break;
        case "player":



          if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
              this.videoPlayerRef.current.handleReady();
          if ((this.timelineRef) && (this.timelineRef.current))
              this.timelineRef.current.forceRecreate();

          if ((this.transcriptRef) && (this.transcriptRef.current))
            this.transcriptRef.current.setState({currentTime: this.state.currentTime})

          //if ((this.editListeStRef) && (this.editListeStRef.current))
          //  this.editListeStRef.current.Refresh();

          break;
      }
    }
    // *********************************************************************************************************************
    // toolsbar Events
    // *********************************************************************************************************************
    onClickToolsBar(datas)
    {
    
      switch (datas.cat)
      {
        default:
          break;
      }
    }
    // *********************************************************************************************************************
    // player Events
    // *********************************************************************************************************************
    
    videoReady(duration)
    {
        if ((this.timelineRef) && (this.timelineRef.current))
            this.timelineRef.current.setCurrentDuration(duration);
  
    }

    onNewTime(time)
    {
      if ((this.timelineRef) && (this.timelineRef.current))
      {
          try
          {
            this.timelineRef.current.setCurrentTime(time);
          }
          catch
          {
            return;
          }
      }
    }    

    // *********************************************************************************************************************
    // ASsets Manager Events
    // *********************************************************************************************************************
    onClickOnAsset(asset, type="")
    {
        // on a clicquer sur un asset
          console.log ("on click on asset ", asset, type)

      if (asset.astype === 1) // on choisie une nouvelle transcription orginale
      {
          apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAsset);
      }
      if (asset.astype === 2) // on choisie une nouvelle transcription corrigée
      {
          apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAsset);
          if (asset.asoriid > 0)
            apiReadOneAsset ({asid: asset.asoriid}, this.appSubtitles_apiCallBackReadOneAsset);
      }



      if (asset.astype == 3)
      {
        

        if (type === "")
          {
            if ((this.timelineRef) && (this.timelineRef.current))
            {
                  apiReadOneVideo({viid: asset.asviid},this.appSubtitles_startWithOneVideoCallback);
            }
          }
  

        if (type === "cp")
        {
          if ((this.timelineRef) && (this.timelineRef.current))
          {
                apiReadOneVideo({viid: asset.asviid},this.appSubtitles_onReadVideoForCP);
          }
        }
        if (type === "audio1")
          {
            if ((this.timelineRef) && (this.timelineRef.current))
            {
                  apiReadOneVideo({viid: asset.asviid},this.appSubtitles_onReadVideoForAudio1);
            }
          }
          if (type === "audio2")
            {
              if ((this.timelineRef) && (this.timelineRef.current))
              {
                    apiReadOneVideo({viid: asset.asviid},this.appSubtitles_onReadVideoForAudio2);
              }
            }
            return;
        }

    }
    
    onAssetsManagerChange(datas)
    {
      // l'assets manager a changé ou reloadé sa liste d'asset
      this.assetsList = datas;


      
    }

    

    // *********************************************************************************************************************
    // rendering....
    // *********************************************************************************************************************

    render ()
    {
  
      var apptitle = "AUDIO DESCRIPTION / V.O.";
      if (this.context.language === "en") apptitle="AUDIO DESCRIPTION / V.O.";
      // https://neweasysubdatas.easydirect.fr/videos/BR0217LN_EasySub.mp4
     
      return (
        <div className={styles.appDiv}  tabIndex={0} id="AppTranscriptContainer">
          <div className={styles.appDivTop}>
            <div className={styles.appDivLogoFtva}>
                <img src={ftva} style = {{width:"100%", verticalAlign:"middle"}}/>
            </div>
   <        div className={styles.appDivProject}>
                <div className={styles.appDivProjectLeft}>
                <h1>{apptitle}</h1>
                </div>
                <div className={styles.appDivProjectRight}>
                <AppHeader onCancelKeyboardEvent={this.onCancelKeyboardEvent} ref={this.appHeaderRef} canclose={false} canedit={true}/>
                </div>
  
            </div>
          <div className={styles.appDivLogo}>
            <Icon image={easytt} height="100%" width="100%"/>
            </div>
            <div className={styles.appDivUser}>
            <User onnavigate = {this.props.onnavigate} onCancelKeyboardEvent={this.onCancelKeyboardEvent}/>
            </div>
          </div>
          <div className={styles.appDivToolsBar}>
              <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar}/>
          </div>
          <div className={styles.appDivBody} ref = {this.bodyDivRef}>
            
            <div className={styles.appPanelsContainer} 
              div tabIndex={1} 
              style = {{outline:"none"}}
              ref = {this.divEditSTRef} 
              >
  
            
              <AppSettings playerparams={this.playerparams} subtitleParameters={this.subtitleParameters} onchange={this.onchangeparams}>
              
              <PanelGroup direction="vertical">
              <Panel>
                  <PanelGroup direction="horizontal">
                      <Panel className={styles.appPanel} defaultSize={10}>
                          <PanelGroup direction="vertical" >
                              <Panel className={styles.appPanelBorder} >
                              <AssetsManager 
                                  pjid={this.state.pjid} 
                                  mode = "transcript"
                                  onCancelKeyboardEvent = {this.onCancelKeyboardEvent}
                                  onClick = {this.onClickOnAsset}
                                  onChange = {this.onAssetsManagerChange}
                                  ref={this.assetsManagerRef}/>
                               </Panel>
                              <AppResizeHandle />
                              <Panel className={styles.appPanelBorder} >
                                <EnTravaux encours={false} title="Speakers"/>
                              </Panel>
                          </PanelGroup>
                      </Panel>
                      <AppResizeHandle />
                
                      <Panel className={styles.appPanelBorder} defaultSize={18}>

                      

                      
                          
                          
                      </Panel>
                      <AppResizeHandle />
                      <Panel className={styles.appPanel}  defaultSize={45}>
                          <PanelGroup direction="vertical" >
                              <Panel className={styles.appPanelBorder} defaultSize={85}>
                              <VideoPlayerST
                                  ref={this.videoPlayerRef} 
                                  src={this.state.videopath}
                                  video={this.state.videoforplayer}
                                  readOnly={true}

                                  getTimeCodeString = {this.getTimeCodeString}

                                  redo={this.state.redo}
                                  undo={this.state.undo}

                                  subtitleParameters={this.subtitleParameters}
                                  displayParameters={this.displayParameters}

                                  onChange={this.subtitlelist_change}                                  
                                  onMove={this.subtitlelist_move}
                              
                                  addNewActionForUndo={this.subtitlelist_addNewActionForUndo}
                                  onUndoOrRedo={this.subtitlelist_onUndoOrRedo}

                                  onNewTime={this.onNewTime}
                                  onready={this.videoReady}
                                  params={this.playerparams}
                              
                                  onChangeSubtitle={this.subtitle_onChangeSubtitle}

                                  />
                              </Panel>
                          </PanelGroup>
                      </Panel>
  
                      <AppResizeHandle />
                
                      <Panel className={styles.appPanelBorder} defaultSize={20}>

                          <EditListSt
                          ref={this.editListeStRef}
                          onCheckSubtitle = {this.app_subtitles_checkSubtitle}

                          getTimeCodeString = {this.getTimeCodeString}
                          getIntervalString = {this.getIntervalString}

                          readOnly={true}

                          onChange={(subtitle) =>
                            this.subtitlelist_change(subtitle, 'editListSt')
                          }
                          onMove={(id, timecode) =>
                            this.subtitlelist_move(id, timecode, 'editListSt')
                          }
                          Zindex={0}
                          subtitleParameters={this.subtitleParameters}
                          displayParameters={this.displayParameters}
                          undo={this.state.undo}
                          redo={this.state.redo}
                          onSave = {this.saveSubtitles}
                          addNewActionForUndo={this.subtitlelist_addNewActionForUndo}
                          onUndoOrRedo={(key, action) =>
                            this.subtitlelist_onUndoOrRedo(key, action, 'editListSt')
                          }
                          onApplyFilter={this.subtitlelist_applyFilter}
                        ></EditListSt>
      

                          
                      </Panel>
  
                  </PanelGroup>
                </Panel>
                  <AppResizeHandle/>
  
                  <Panel ref = {this.timelinePanelRef} className={styles.appPanelBorder}  maxSize={40} minSize={2} defaultSize={this.state.timelineHeight}>
                    <TimeLine ref = {this.timelineRef}  forceResize ={this.forceResizeTimeLine} 
                    playaddtime={this.handleTimeLineWheel}
                    type="audiodescription"
                    gototime={this.handleGotoTime}
                    getTimeCodeString = {this.getTimeCodeString}
                    onCpListLoaded = {this.handleCpListLoaded}
                    
                    />

                    
                  </Panel>
                </PanelGroup>
              
                </AppSettings>
              </div>
            
            </div>
            
        </div>
      
      )
      }
  
  
  

    // *********************************************************************************************************************************
    // * Emmanuelle...
    // * subtitlelist, subtitleedit
    // *********************************************************************************************************************************
  
  
    subtitle_GetEditSubtitleRef()
    {
      
      if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
      {
        if ((this.videoPlayerRef.current.editSubtitleRef) && (this.videoPlayerRef.current.editSubtitleRef.current))
          return this.videoPlayerRef.current.editSubtitleRef.current;
      }
      return null;
    }


    subtitlelist_setNewCorrectedSubtitles(id, json)
    {
      
      const subtitles = json.subtitles.map((subtitle, index) => ({
        ...subtitle,
        id: index,
      }))

      console.log("json", json);

      this.setState({ subtitles });

      const currentSubtitle = subtitles[this.state.currentSubtitleIndex];


      if ((this.editListeStRef) && (this.editListeStRef.current))
        this.editListeStRef.current.setSubtitles(
          id,
          this.subtitleParameters,
        subtitles
      );


      if (this.subtitle_GetEditSubtitleRef())
        this.subtitle_GetEditSubtitleRef().initSubtitle(
        id,
        currentSubtitle,
        false
      );
    }


    subtitle_onChangeSubtitle(timecode) {
    
      const { subtitles } = this.state;
      const subtitle = subtitles.find(x => x.in <= timecode && timecode <= x.out);

  

      if (subtitle) {

        this.setState({
          currentSubtitleIndex: subtitle.id,
        });


        if (this.editListeStRef && this.editListeStRef.current) {
    
          const editListeStRef = this.editListeStRef.current;

          editListeStRef.setCurrentSubtitle(
            subtitle.id,
            editListeStRef.active
          );
        }
    
        const editSubtitleRef = this.subtitle_GetEditSubtitleRef();
        if (editSubtitleRef) {
          const editSubtitleRef = this.subtitle_GetEditSubtitleRef();
          editSubtitleRef.setCurrentSubtitle(subtitle, editSubtitleRef.active);
        }


      }

    }

    // *********************************************************************************************************************
    // subtitle list event
    // *********************************************************************************************************************

    subtitlelist_onInsertSubtitle(addToEnd = false) {
      const { subtitles, currentSubtitleIndex } = this.state;
      let { undo, redo } = this.state;
  
      const newSubtitle = {
        len: 0,
        lines: [{ len: 0, verticalPos: 20, align: 2, words: [] }],
      };

      const actionType = 'OnInsertSubtitle';
  
      if (addToEnd) {
        const currentSubtitle = subtitles[currentSubtitleIndex];
  
        newSubtitle.id = currentSubtitle.id + 1;
        newSubtitle.in = currentSubtitle.out;
        newSubtitle.out = currentSubtitle.out + this.subtitleParameters.min; // TODO prendre params des sous-titres, si pas params prendre displayParameters;
  
        // undo
        const undoAction = {
          undo: {
            actionType,
            subtitles: [newSubtitle],
            currentSubtitleId: newSubtitle.id,
            isLastSubtitle: true,
          },
          redo: undefined,
        };
  
        undo.push(undoAction);
        subtitles.push(newSubtitle);
      } else {
        const prevSubtitle = subtitles[currentSubtitleIndex - 1];
        const currentSubtitle = subtitles[currentSubtitleIndex];
  
        newSubtitle.in = prevSubtitle ? prevSubtitle.out : 0;
        newSubtitle.out = currentSubtitle.in;
  
        // undo
        const undoAction = {
          undo: {
            actionType,
            subtitles: [newSubtitle],
            currentSubtitleId: currentSubtitle.id,
          },
          redo: undefined,
        };
  
        undo.push(undoAction);
  
        subtitles.splice(currentSubtitle.id, 0, newSubtitle);
        subtitles.forEach((subtitle, index) => (subtitle.id = index));
      }
  
      this.setState({ ...this.state, subtitles, undo, redo });
  
      this.editListeStRef.current.updateSubtitles(
        subtitles,
        currentSubtitleIndex
      );
  
      this.subtitle_GetEditSubtitleRef().updateSubtitle(
        subtitles[currentSubtitleIndex]
      );
  
      this.setSubtitlesChange(subtitles);
    }
  
    subtitlelist_onDeleteSubtitle() {
      const { subtitles, currentSubtitleIndex } = this.state;
      let { undo, redo } = this.state;

      const subtitleToDelete = subtitles[currentSubtitleIndex];

      if (!undo) {
        undo = [];
      }

      if (undo.length === getMaxUndo()) {
        undo.shift();
      }

      redo = [];
  
      const undoAction = {
        undo: {
          actionType: 'OnDeleteSubtitle',
          subtitles: [cloneDeep(subtitleToDelete)],
          currentSubtitleId: subtitleToDelete.id,
        },
        redo: undefined,
      };
  
      undo.push(undoAction);
  
      subtitles.splice(currentSubtitleIndex, 1);
  
      subtitles.forEach((subtitle, index) => (subtitle.id = index));
  
      this.setState({ ...this.state, subtitles, undo, redo });
  
      this.editListeStRef.current.updateSubtitles(
        subtitles,
        currentSubtitleIndex
      );
  
      this.subtitle_GetEditSubtitleRef().updateSubtitle(
        subtitles[currentSubtitleIndex]
      );
  
      this.setSubtitlesChange(subtitles);
    }


  subtitlelist_move(id, timeCode, from) {
      
    if (id === -1) {

      if (this.subtitle_GetEditSubtitleRef()) {
        this.subtitle_GetEditSubtitleRef().clearCurrentSubtitle();
      }

      return;
    }
 
    this.setState({ currentSubtitleIndex: id });
    const currentSubtitle = this.state.subtitles.find((x) => x.id === id);

    if (!currentSubtitle) {
      return;
    }

    if (this.editListeStRef && this.editListeStRef.current) {
    
      this.editListeStRef.current.setCurrentSubtitle(
        id,
        from === 'editListSt'
      );
    }

    if (this.subtitle_GetEditSubtitleRef()) {
      this.subtitle_GetEditSubtitleRef().setCurrentSubtitle(currentSubtitle, from === 'editSubtitle');
    }

        if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
          this.videoPlayerRef.current.goto(currentSubtitle.in);

  }



    subtitlelist_change(
      updatedSubtitle,
      from
    ) {      
      const { subtitles } = this.state;
      const updatedSubtitles = subtitles.map((subtitle) =>
        subtitle.id === updatedSubtitle.id ? cloneDeep(updatedSubtitle) : subtitle
      );
      this.setState({ subtitles: updatedSubtitles });
  
      if (from === 'editListSt') 
        {
        if (this.subtitle_GetEditSubtitleRef())
          this.subtitle_GetEditSubtitleRef().updateSubtitle(updatedSubtitle);
      } else {
        if ((this.editListeStRef) && (this.editListeStRef.current))
            this.editListeStRef.current.updateSubtitle(updatedSubtitle);
      }

      
      this.setSubtitlesChange(updatedSubtitles)

    }
  
    subtitlelist_applyFilter(action) {  
      const { subtitles, currentSubtitleIndex } = this.state;

      let { undo, redo } = this.state;
  
      if (!undo) {
        undo = [];
      }

      if (undo.length === getMaxUndo()) {
        undo.shift();
      }
  
      redo = [];
      
      let undoAction;
      let ids;
      let actionType;
      let currentSubtitleId;

      switch (action.name) {
        case 'color':
          actionType = 'onSetColorOnSubtitlesSelected';
          ids = new Set(action.subtitlesSelected.map((x) => x.id));

          break;
        
        case 'colorFiltered':
          actionType = 'onSetColorOnSubtitlesFiltered';
          ids = new Set(action.subtitlesFiltered.map((x) => x.id));
          break;

        case 'delete':
          ids = new Set(action.subtitlesSelected.map((x) => x.id));
          actionType = 'onDeleteOnSubtitlesSelected';
          break;
    
        case 'duplicate':
          ids = new Set(action.selectedSubtitles.map((x) => x.id));
          actionType = 'onDuplicateOnSubtitlesSelected';
          currentSubtitleId = action.idTo;
          break;
        
        case 'cutAndPaste':
          ids = new Set(subtitles.map((x) => x.id));
          actionType = 'onCutAndPasteOnSubtitlesSelected';
          break;

        case 'replaceAll':
          const { wordsToSearch } = action.replace;

          ids = new Set(wordsToSearch.map((w) => w.id));
          actionType = 'OnReplaceAll';

          break;

        default:
          return;
      }

      const subtitlesToUndo = cloneDeep(subtitles.filter((x) => ids.has(x.id)));

      undoAction = {
        undo: {
          actionType,
          subtitles: subtitlesToUndo,
          currentSubtitleId: currentSubtitleId ?? ids.values().next().value,
        },
        redo: undefined,
      };

      undo.push(undoAction);
      this.setState({ ...this.state, undo, redo });
  
      if (action.name === 'color') {
        const updatedSubtitles = subtitles.map((subtitle) => {
          const subtitleToUpdate = action.subtitlesSelected.find(
            (x) => x.id === subtitle.id
          );
          if (subtitleToUpdate) {

            const words = flatMapDeep(subtitleToUpdate.lines.map((w) => w.words));

            words.forEach((word) => {
              word.color = action.color.hex;
            });

            return cloneDeep(subtitleToUpdate);
          }
  
          return subtitle;
        });
  
        this.setState({ subtitles: updatedSubtitles });
  
        const currentSubtitle = updatedSubtitles.find(
          (x) => x.id === currentSubtitleIndex
        );
  
        this.editListeStRef.current.updateSubtitles(
          updatedSubtitles,
          currentSubtitle.id
        );
  
        this.subtitle_GetEditSubtitleRef().updateSubtitle(currentSubtitle);
        this.setSubtitlesChange(updatedSubtitles);
        return;
      }

      if (action.name === 'colorFiltered') {
        const updatedSubtitles = subtitles.map((existingSubtitle) => {
          const updatedSubtitle = action.subtitlesFiltered.find(
            (subtitle) => subtitle.id === existingSubtitle.id
          );
  
          return updatedSubtitle ? cloneDeep(updatedSubtitle) : existingSubtitle;
        });
  
        this.setState({ subtitles: updatedSubtitles });
  
        const currentSubtitle = updatedSubtitles.find(
          (x) => x.id === currentSubtitleIndex
        );
  
        this.editListeStRef.current.updateSubtitles(
          updatedSubtitles,
          currentSubtitle.id
        );
  
        this.subtitle_GetEditSubtitleRef().updateSubtitle(currentSubtitle);


        this.setSubtitlesChange(updatedSubtitles);
        return;
      }
  
      if (action.name === 'delete') {
        const selectedSubtitlesIds = action.subtitlesSelected.map((x) => x.id);
        const firstSubtitleId = first(selectedSubtitlesIds);
        const index = subtitles.findIndex((x) => x.id === firstSubtitleId);
  
        const updatedSubtitles = subtitles.filter(
          (subtitle) => !selectedSubtitlesIds.includes(subtitle.id)
        );
  
        // Réinitialiser les index
        updatedSubtitles.forEach((subtitle, index) => {
          subtitle.id = index;
        });
  
        this.setState({ subtitles: updatedSubtitles });
  
        const moveToSubtitle =
          index === 0 ? updatedSubtitles[0] : updatedSubtitles[index - 1];
  
        this.editListeStRef.current.updateSubtitles(
          updatedSubtitles,
          moveToSubtitle.id
        );
  
        this.subtitle_GetEditSubtitleRef().updateSubtitle(moveToSubtitle);

        this.setSubtitlesChange(updatedSubtitles);
        return;
      }
  
      if (action.name === 'duplicate' || action.name === 'cutAndPaste') {
        const { idTo, selectedSubtitles } = action;
  
        const subtitleDuplicateTo = subtitles.find((x) => x.id === idTo - 1);
        const beforeSubtitle = subtitles.find((x) => x.id === idTo);
        if (!subtitleDuplicateTo) {
          return;
        }
  
        let inTime = subtitleDuplicateTo.out;
        const outTime = beforeSubtitle.in;
        let inOutTime = inTime;
  
        // recalculer les timecodes
        selectedSubtitles.forEach((subtitle) => {
          subtitle.in = inOutTime;
  
          subtitle.lines.forEach((line) => {
            const sentence = line.words.map((x) => x.text).join(' ');
  
            const duration = outTime - inOutTime;
  
            line.words.forEach((word) => {
              const time = (duration / sentence.length) * word.text.length;
              inOutTime = parseFloat((inTime + time).toFixed(2));
  
              word.in = inTime;
              word.out = inOutTime;
  
              inTime = inOutTime;
            });
          });
  
          subtitle.out = inOutTime;
        });
  
        subtitles.splice(idTo, 0, ...selectedSubtitles);
  
        if (action.name === 'cutAndPaste') {
          // On supprime
          subtitles.splice(first(selectedSubtitles).id, selectedSubtitles.length);
        }
  
        // Réinitialiser les index
        subtitles.forEach((subtitle, index) => {
          subtitle.id = index;
          subtitle.selected = false;
        });
  
        this.setState({ subtitles });
  
        this.editListeStRef.current.updateSubtitles(
          subtitles,
          action.name === 'cutAndPaste'
            ? action.idTo - selectedSubtitles.length
            : action.idTo
        );
        this.setSubtitlesChange(subtitles);
        return;
      }
  
      if (action.name === 'replaceAll') {
        const { text, searchText, wordsToSearch } = action.replace;
  
        wordsToSearch.forEach((wordToSearch) => {
          const subtitle = subtitles.find((x) => x.id === wordToSearch.id);
  
          if (subtitle) {
            const words = flatMapDeep(subtitle.lines.map((x) => x.words));
  
            const wordToReplace = words.find((x) => x.text === wordToSearch.text);
  
            if (wordToReplace) {
              wordToReplace.text = wordToReplace.text.replace(searchText, text);
            }
          }
        });
  
        this.setState({ subtitles });
  
        const currentSubtitle = first(wordsToSearch);
  
        this.editListeStRef.current.updateSubtitles(
          subtitles,
          currentSubtitle.id
        );
        this.setSubtitlesChange(subtitles);

        return;
      }
    }
  
  subtitlelist_prevSubtitle(event) {
    console.log('prevSubtitle');

    if (this.state.currentSubtitleIndex === 0) return;

    const newCurrentSubtitleIndex = this.state.currentSubtitleIndex - 1;

    this.setState({
      currentSubtitleIndex: newCurrentSubtitleIndex,
    });

    const currentSubtitle = this.state.subtitles[newCurrentSubtitleIndex];
    const editListeStRef = this.editListeStRef.current;
    const editSubtitleRef = this.subtitle_GetEditSubtitleRef();

    editListeStRef.setCurrentSubtitle(currentSubtitle.id, editListeStRef.active);

    editSubtitleRef.setCurrentSubtitle(
      currentSubtitle, editSubtitleRef.active
    );
   
    if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
      this.videoPlayerRef.current.goto(currentSubtitle.in);

    /*if (event) {
      event.target.blur();
    }*/
  }

  subtitlelist_nextSubtitle(event) {
    console.log('nextSubtitle');

    if (this.state.currentSubtitleIndex === this.state.subtitles.length - 1)
      return;

    const newCurrentSubtitleIndex = this.state.currentSubtitleIndex + 1;

    this.setState({
      currentSubtitleIndex: newCurrentSubtitleIndex,
    });

    const currentSubtitle = this.state.subtitles[newCurrentSubtitleIndex];
    const editListeStRef = this.editListeStRef.current;
    const editSubtitleRef = this.subtitle_GetEditSubtitleRef();

    console.log("editListeStRef - active", editListeStRef.active);
    console.log("editSubtitleRef - active", editSubtitleRef.active);

    editListeStRef.setCurrentSubtitle(currentSubtitle.id, editListeStRef.active);

    editSubtitleRef.setCurrentSubtitle(
      currentSubtitle, editSubtitleRef.active
    );

     if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
      this.videoPlayerRef.current.goto(currentSubtitle.in);

    /*if (event) {
      event.target.blur();
    }*/
  }




    subtitlelist_addNewActionForUndo(action) {
      if (!action) {
        return;
      }
  
      let { redo, undo } = this.state;
  
      redo = [];
  
      if (!undo) {
        undo = [];
      }

      if (undo.length === getMaxUndo()) {
        undo.shift();
      }
  
      undo.push(cloneDeep(action));
  
      this.setState({ ...this.state, redo, undo });
    }
  
    subtitlelist_onUndoOrRedo(key, action, from) {
      if (!action) {
        return;
      }
  
      const { redo, undo } = this.state;
      const isRedo = key === 'REDO';
  
      if (isRedo) {
        if (redo.length === 0) {
          return;
        }
        redo.shift();
        undo.push(action);
      } else {
        if (undo.length === 0) {
          return;
        }
  
        redo.unshift(action);
        undo.pop();
      }
  
      this.setState({ ...this.state, redo, undo });

      const applyAction = isRedo ? action.redo : action.undo;
  
      if (applyAction.subtitles) {
        this.subtitlelist_onUndoOrRedoOnSubtitles(isRedo, applyAction);
        return;
      }
  
      this.subtitlelist_onUndoOrRedoOnOneSubtitle(applyAction, from);
    }
  
    subtitlelist_onUndoOrRedoOnOneSubtitle(action, from) {
      const { subtitles } = this.state;
      const updatedSubtitles = subtitles.map((subtitle) =>
        subtitle.id === action.subtitle.id ? cloneDeep(action.subtitle) : subtitle
      );
  
      this.setState({ subtitles: updatedSubtitles });
  
      this.editListeStRef.current.updateSubtitleAfterUndoOrRedo(
        action,
        from === 'editListSt'
      );
  
      this.subtitle_GetEditSubtitleRef().updateSubtitleAfterUndoOrRedo(
        action,
        from === 'editSubtitle'
      );
      this.setSubtitlesChange(updatedSubtitles);
    }
  
    subtitlelist_onUndoOrRedoOnSubtitles(isRedo, action) {
      if (
        action.actionType === 'OnDeleteSubtitle' ||
        action.actionType === 'onDeleteOnSubtitlesSelected'
      ) {
        this.subtitlelist_onUndoOrRedoForInsertOrDeleteSubtitles(isRedo, action, false);
        return;
      }
  
      if (
        action.actionType === 'onDuplicateOnSubtitlesSelected' ||
        action.actionType === 'OnInsertSubtitle'
      ) {
        this.subtitlelist_onUndoOrRedoForInsertOrDeleteSubtitles(isRedo, action, true);
        return;
      }
  
      // TODO onCutAndPasteOnSubtitlesSelected
  
      const { subtitles } = this.state;
  
      const updatedSubtitles = subtitles.map((subtitle) => {
        const subtitleToUndo = action.subtitles.find((x) => x.id === subtitle.id);
        if (subtitleToUndo) {
          return cloneDeep(subtitleToUndo);
        }
  
        return subtitle;
      });
  
      this.setState({ subtitles: updatedSubtitles });
  
      const currentSubtitle = updatedSubtitles.find(
        (x) => x.id === action.currentSubtitleId
      );
  
      this.editListeStRef.current.updateSubtitles(
        updatedSubtitles,
        currentSubtitle.id
      );
  
      this.subtitle_GetEditSubtitleRef().updateSubtitle(currentSubtitle);
      this.setSubtitlesChange(updatedSubtitles);
    }
  
    subtitlelist_onUndoOrRedoForInsertOrDeleteSubtitles(isRedo, action, revert) {
      const { subtitles } = this.state;
      const { currentSubtitleId, subtitles: subs, isLastSubtitle } = action;
  
      if (revert) {
        if (isRedo) {
          subtitles.splice(currentSubtitleId, 0, ...subs);
        } else {
          subtitles.splice(currentSubtitleId, subs.length);
        }
      } else {
        if (isRedo) {
          subtitles.splice(currentSubtitleId, subs.length);
        } else {
          subtitles.splice(currentSubtitleId, 0, ...subs);
        }
      }
  
      subtitles.forEach((sub, index) => (sub.id = index));
  
      this.setState({ subtitles });
  
      const currentSubtitle = isLastSubtitle
      ? last(subtitles)
      : subtitles.find((x) => x.id === currentSubtitleId);
  
      this.editListeStRef.current.updateSubtitles(subtitles, currentSubtitle.id);
  
      this.subtitle_GetEditSubtitleRef().updateSubtitle(currentSubtitle);
  
      this.setSubtitlesChange(subtitles);
    }

  }
  export default AppAd;